module.exports = __webpack_public_path__ + "static/media/LOOK LIKE.2014b9ec.jpg";